import isApiError from "@insite/client-framework/Common/isApiError";
import { get, post } from "@insite/client-framework/Services/ApiService";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";

export interface ApiResultModel {
    uri?: string;
    podOrderStatusSummary?: {
        count?: number;
        frequency?: string;
    };
    subscribedEmails?: SubscribedEmailDto[];
    properties?: {
        [key: string]: string;
    };
}

export interface ApplyPodSubscriptionsApiResultModel {
    uri: string;
    podOrderStatusSummary: {
        count: Number;
        frequency: string;
    }
    subscribedEmails: SubscribedEmailDto [];
    properties: {
        [key: string]: string;
    };
}

const url = "/api/v1/podSummary";

export async function getPodSubscribers(customerId?: string) {
    const queryParams = customerId ? `?customerId=${customerId}` : "";
    try {
        const result = await get<ApiResultModel>(`${url}${queryParams}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}

export async function applyPodSubscriptionsService(
    customerId: string,
    subscribedEmails: SubscribedEmailDto[],
    frequency: string,
) {
    try {
        const result = await post<
            { customerId: string; subscribedEmails: SubscribedEmailDto[]; frequency: string },
            ApplyPodSubscriptionsApiResultModel
        >(`${url}`, {
            customerId,
            subscribedEmails,
            frequency,
        });

        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}
